import React, {useEffect, useState} from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import {useSelector} from "react-redux";
import {selectProfileInfo} from "../../../store/selectors/Profile";
import TextBox from '../../Common/Textbox/small'
import TextArea from '../../Common/Textbox/textarea'
import Button from '../../Common/Buttons/small'

const loginSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("Required")
    .nullable(),
  secondName: Yup.string()
    .required("Required")
    .nullable(),
  about: Yup.string()
    .max(1000, "Maximum 1000 characters allowed")
    .required("Required")
    .nullable(),
});

const SetupForm = ({ handleSubmit, submitBtnTitle, isLoading }) => {

  const profileData = useSelector(selectProfileInfo);
  const [initValue, setInitValues] = useState({
    firstName: profileData.firstName,
    secondName: profileData.secondName,
    about: profileData.about,
  });

  useEffect(() => {
    setInitValues(profileData)
  }, [profileData])

  return (
      <Formik
          enableReinitialize={true}
          initialValues={initValue}
          validationSchema={loginSchema}
          onSubmit={(values) => {
            handleSubmit(values)
          }}
      >
      {(props) => {
        const { handleChange, errors, values } = props;
        return (
          <Form className={"setupForm"}>
            <div className={"nameContainer"}>
              <div className={"inputContainerWrapper"}>
                <div className={"inputContainer"}>
                  <TextBox  placeholder="" error={!!errors.firstName} value={values.firstName} type={"text"}
                      handleChange={handleChange} tName={"firstName"} label={"First name"} additionClass={'EMPHASIS_LARGE smallInput'} htmlFor="outlined-basic-firstName" />
                  <ErrorMessage className="error" name="firstName" component="div" />
                </div>

                <div className={"inputContainer"}>
                  <TextBox placeholder=""  error={!!errors.secondName} value={values.secondName} type={"text"}
                      handleChange={handleChange} tName={"secondName"} label={"Last name"} additionClass={'EMPHASIS_LARGE smallInput'} htmlFor="outlined-basic-secondName" />
                  <ErrorMessage className="error" name="secondName" component="div" />
                </div>


              </div>
            </div>
            <div className={"areaContainer"}>

                <div className={"inputContainer"}>
                  <TextArea placeholder="Please write a short description about your teaching experience and methodologies." multiline={true}  error={!!errors.about} value={values.about} type={"text"}
                      handleChange={handleChange}  rows={4}  defaultV={`Contact Info: 
Experience: 
Education: 
Class Rates: `} tName={"about"} label={"About"} additionClass={'EMPHASIS_LARGE textarea'}
                       htmlFor="outlined-basic-about" />
                  <ErrorMessage className="error" name="about" component="div" />
                </div>


            </div>
            <div className={"CENTER_FLEX"}>
              <div className={"END_FLEX"}>
                <Button loading={isLoading} additionClass={""} text={submitBtnTitle} />
              </div>

            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default SetupForm;
